var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabContent" },
    [
      _c("reports-sidebar", {
        attrs: { menuItems: _vm.menu },
        on: { toggle: _vm.changeReport }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "reports-content-container" },
        [
          !_vm.selectedReport && !_vm.loading
            ? _c("div", { staticClass: "warning-text" }, [
                _c("div", { staticClass: "message-title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("NoReportSelected")) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "message-description" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("SelectReportFromMenu")) +
                      "\n      "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedReport && !_vm.selectedReport.page
            ? _c("div", { staticClass: "warning-text" }, [
                _c("div", { staticClass: "message-title" }, [
                  _vm._v(_vm._s(_vm.$t("PageInConstruction")))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedReport && _vm.selectedReport.page
            ? _c(_vm.selectedReport.page, {
                tag: "component",
                attrs: {
                  name: _vm.selectedReport.name,
                  version: _vm.selectedReport.version,
                  "custom-json": _vm.selectedReport.customJson
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("loading-spinner", {
            attrs: {
              active: _vm.loading,
              "is-full-page": false,
              color: "#4fa2b7"
            },
            on: {
              "update:active": function($event) {
                _vm.loading = $event
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e3dd8c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e3dd8c1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Reports/ReportsTab.vue
// module id = null
// module chunks = 